<template>
  <div>
    <VolumeEdit ref="VolumeEdit" v-on:editComplete="VolumeEditComplete"></VolumeEdit>
    <Card shadow>
      <Row>
        <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getVolumeData()" style="float: left;"></AllTenantSwitch>
        <div style="float: left;">
          <Form ref="searchForm" inline @submit.native.prevent :model="searchForm" :label-width="50">
            <FormItem label="名称">
              <Input v-model="searchForm.name" style="min-width: 150px;" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getVolumeData()">搜索</Button>
              <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </div>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getVolumeData(volume.page)">刷新</Button>
          <Button
            @click="$refs.VolumeEdit.openModal()"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建云硬盘</Button>
        </div>
      </Row>
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="volume.data"
        :columns="volume.columns">
        <template slot="VolumeActionMenu" slot-scope="props">
          <VolumeActionMenu
            :status="props.row.status"
            :migration_status="props.row.migration_status"
            :replication_status="props.row.replication_status"
            :volume_id="props.row.id"
            :volume_name="props.row.name" v-on:callback="getVolumeData(volume.page)"></VolumeActionMenu>
        </template>
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ volume.data.length }} 条记录，总共 {{ volume.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="volume.count"
            :current="volume.page"
            :page-size="volume.size"
            @on-change="getVolumeData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudVolume } from '@/api/private-cloud/volume'
import { statusTransfer } from '@/view/private-cloud/storage/volume_status_transfer'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import VolumeActionMenu from './components/volume-action-menu'
import VolumeEdit from './components/volume-edit'
import moment from 'moment'

export default {
  components: {
    VolumeEdit,
    VolumeActionMenu,
    AllTenantSwitch,
    moment
  },
  data () {
    return {
      tableLoading: false,
      volume: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'os-vol-tenant-attr:tenant_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row['os-vol-tenant-attr:tenant_id']))
            }
          },
          {
            title: '名称',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'name'
          },
          {
            title: '类型',
            align: 'center',
            minWidth: 120,
            tooltip: true,
            key: 'volume_type'
          },
          {
            title: '大小',
            align: 'center',
            minWidth: 120,
            tooltip: true,
            key: 'size',
            render: (h, params) => {
              return h('span', params.row.size + ' GiB')
            }
          },
          {
            title: '状态',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              return h('Badge', {
                props: {
                  text: statusTransfer(params.row.status).status,
                  status: statusTransfer(params.row.status).color
                }
              })
            }
          },
          // {
          //   title: '类型',
          //   align: 'center',
          //   minWidth: 130,
          //   tooltip: true,
          //   key: 'volume_type'
          // },
          {
            title: '挂载到',
            align: 'center',
            tooltip: true,
            minWidth: 200,
            render: (h, params) => {
              let result = []
              for (let i in params.row.attachments) {
                result.push(
                  h('p', [
                    h('a', {
                      on: {
                        click: () => {
                          this.$router.push({ name: 'private_cloud_server_detail', params: { id: params.row.attachments[i].server_id } })
                        }
                      }
                    }, resourceIdTransName('servers', params.row.attachments[i].server_id)),
                    h('span', ' 实例上的 ' + params.row.attachments[i].device)
                  ])
                )
              }
              return h('div', result)
            }
          },
          {
            title: '可用域',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'availability_zone'
          },
          {
            title: '可启动',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              let color = ''
              let res = params.row.bootable
              if (res === 'True' || res === 'true') {
                res = '是'
                color = '#19be6b'
              } else if (res === 'False' || res === 'false') {
                res = '否'
                color = '#ed4014'
              }
              return h('span', {
                style: {
                  color: color
                }
              }, res)
            }
          },
          {
            title: '加密的',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              let res = '否'
              if (params.row.encrypted) {
                res = '是'
              }
              return h('span', res)
            }
          },
          {
            title: '创建时间',
            align: 'center',
            tooltip: true,
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 260,
            render: (h, params) => {
              let res = [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'volume_detail', params: { id: params.row.id } })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.VolumeEdit.modifyOpenModal(params.row)
                    }
                  }
                }, '编辑')
              ]
              res.push(
                this.$refs.table.$scopedSlots.VolumeActionMenu({
                  row: params.row,
                  idx: params.row._index
                })
              )
              return h('div', res)
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      searchForm: {
        name: ''
      }
    }
  },
  mounted: function () {
    this.getVolumeData()
  },
  methods: {
    // 获取云硬盘列表数据
    getVolumeData (value = 1) {
      this.volume.page = value
      let params = {
        page: this.volume.page,
        size: this.volume.size,
        name: this.searchForm.name,
        all_tenants: this.$refs.AllTenantSwitch.allTenants()
      }
      this.tableLoading = true
      getPrivateCloudVolume(params).then(res => {
        this.volume.data = res.data.results
        this.volume.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取云硬盘列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取云硬盘列表失败！'
          })
        }
      })
    },
    // 云硬盘编辑完成
    VolumeEditComplete () {
      this.getVolumeData(this.volume.page)
    },
    // 重置搜索表单
    searchFormReset () {
      this.searchForm = {
        name: ''
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
